<template>
	<div class="center center-padding">



		<div v-if="this.isLoggedIn && this.userModel" class="flexheader"
			style="margin-bottom:10px;position:sticky;top:100px;z-index:10;background: white;padding:10px;height:50px;">

			<Circle fileName="w3_reload_white" padding="20%" color="--grey-5" style="margin-right:5px;"
				:class="this.spinners.userModel ? 'spinner' : ''" @click="getUserModel()" />

			<div>
				<Circle fileName="w3_bars_white" padding="20%" color="--grey-5" style="margin-right:5px;"
					@click="this.showOrderListMenu = !this.showOrderListMenu" />

				<div v-if="this.showOrderListMenu"
					style="position:absolute;margin-top:0px;width:300px;height:auto;background-color:var(--grey-1);padding:10px;border-radius:0px 0px 0px 0px;"
					class="drop-shadow" @mouseleave="this.showOrderListMenu = false;">
					<div class="order-item link" @click="createOrder({ dropship: false });">Skapa ny order</div>
					<div class="order-item link" @click="createOrder({ dropship: true });">Skapa ny order (dropship)</div>
					<div class="order-item link" @click="closeAllOrders();">Stäng alla ordrar</div>
					<div class="order-item link" @click="expandAllOrders();">Öppna alla ordrar</div>
				</div>

			</div>

			<h3 class="flexcenter">
				Era ordrar
			</h3>


			<div style="margin-left:5px;background:transparent; flex-grow:1;">
				<div class="form textField" style="max-width:400px;"
					:title="'Sök efter ordernummer, artikelnummer eller benämning'">
					<input type="text" placeholder=" Sök efter ordernummer, artikelnummer eller benämning"
						style="min-width:200px;" v-model="this.filterInput" />
					<img src="@/assets/w3_button_close_light.png" @click="this.filterInput = ''">
				</div>
			</div>

			<div class="flexcenter badge" style="">
				{{ orderListLength }}
			</div>
		</div>

		<div v-else>
			<LoginRequired @showSubMenuLogin="(() => { this.$emit('showSubMenuLogin') })" />
		</div>



		<OrderList v-if="this.isLoggedIn && userModel && userModel.orderList" />


	</div>
</template>

<script>
import OrderList from '../components/order/OrderList.vue';
import LoginRequired from '../components/user/LoginRequired.vue';
import { USER_STORE_ACTION, USER_STORE_COMMIT, USER_STORE_GETTER } from '../store/user-store';
import { modelMixin } from "@/mixins/modelMixin.js";
import { userMixin } from "@/mixins/userMixin.js";



export default {
	name: "OrderListView",
	components: { OrderList, LoginRequired },
	mixins: [modelMixin, userMixin],
	data() {
		return {
			spinners: { userModel: false },
			filterInput: "",
			showOrderListMenu: false,
		};
	},
	watch: {
		filterInput: function (filter) {
			console.log("FP: watcher: ", filter);
			this.$store.commit(USER_STORE_COMMIT.SET_FILTER, filter);

		}
	},
	computed: {
		userModel() {

			return this.$store.state.userStore.data.userModel

		},
		orderListLength() {
			if (this.userModel && this.userModel.orderList) {
				return this.$store.getters[USER_STORE_GETTER.GET_ORDER_LIST].length
			}

			return 0
		}

	},
	methods: {

		/*getUserModel() {

			if (this.spinners.userModel) {
				if (!window.confirm("Vill du försöka igen?")) {
					return;
				}
			}

			this.spinners.userModel = true

			this.$store.dispatch({ type: USER_STORE_ACTION.GET_USER_MODEL, data: {} }).finally(() => {
				this.spinners.userModel = false
			})

		},*/
		
		closeAllOrders() {
			this.$store.commit(USER_STORE_ACTION.CLOSE_ALL_ORDERS)
		},

		expandAllOrders() {
			this.$store.commit(USER_STORE_ACTION.EXPAND_ALL_ORDERS)
		},

		resetCurrentOrderId() {
			this.$store.commit(USER_STORE_COMMIT.SET_CURRENT_ORDER_ID, null);
		}

	},
	created(){
		
	}
};
</script>

<style scoped>

div.menu div.menu-item {

	background: var(--grey-2);
	padding: 5px;
	border-radius: 5px;

}

div div.order-item {
	background: var(--grey-3);
	padding: 10px;
	margin-bottom: 5px;

}

</style>